import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Home.scss";

import banner1 from "../assets/images/main_banner_4.jpg";
import banner2 from "../assets/images/main_banner_2.jpg";
import banner3 from "../assets/images/main_banner_5.jpg";

const slides = [
  {
    image: banner1,
    eyebrow: "",
    title: "Mac Does That",
    description:
      "Performance Focus, Built for Apple Intelligence",
    cta1: "Explore Collection",
    cta2: "Contact Us",
  },
  {
    image: banner2,
    eyebrow: "CATEGORY-BASED LAYOUT",
    title: "GEForce RTX 5060",
    description:
      "Your Favorite Game 100+ Frames",
    cta1: "View Products",
    cta2: "Contact Us",
  },
  {
    image: banner3,
    eyebrow: "Explore.Envolve.Aspire",
    title: "Explore.Envolve.Aspire",
    description:
      "Copilot+ PCs are the fastest, most intelligent Windows PCs ever",
    cta1: "Learn More",
    cta2: "Contact Us",
  },
];

function BannerSlider() {
  const settings = {
    autoplay: true,
    autoplaySpeed: 4500,
    dots: true,
    arrows: true,
    infinite: true,
    speed: 650,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
  };

  return (
    <section className="hero-slider">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index}>
            <div
              className="hero-slide"
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="hero-overlay">
                <div className="hero-content">
                  {/* <span className="hero-eyebrow">{slide.eyebrow}</span> */}
                  <h2>{slide.title}</h2>
                  <p>{slide.description}</p>

                  <div className="hero-actions">
                    <a href="#featured-products" className="hero-btn primary">
                      {slide.cta1}
                    </a>
                    <a href="#contact-us" className="hero-btn secondary">
                      {slide.cta2}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}

export default BannerSlider;